/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const updateOrganizationBodyOrganizationNameMin = 2;
export const updateOrganizationBodyOrganizationNameMax = 100;

export const UpdateOrganizationBody = zod
	.object({
		organization: zod.object({
			name: zod
				.string()
				.min(updateOrganizationBodyOrganizationNameMin)
				.max(updateOrganizationBodyOrganizationNameMax)
				.optional()
				.describe('Organization name')
		})
	})
	.describe('Create or update organization request');

export type UpdateOrganizationBody = zod.input<typeof UpdateOrganizationBody>;
export type UpdateOrganizationBodyOutput = zod.output<typeof UpdateOrganizationBody>;
